export default __webpack_public_path__ + "static/media/truck-start.31dfba73.svg";